// console.log("evn",process.env.NODE_ENV);
// if (process.env.NODE_ENV === 'production') {
//     //we are in production-return product key!
//     module.exports = require('./prod-config');
// } else {
//     //we are in dev-return dev key!
//     module.exports = require('./dev-config');
// }

export const MODE = process.env.REACT_APP_MODE || 'TESTNET';
export const BSC_EXPLORER = {
    MAINNET: 'https://bscscan.com',
    TESTNET: 'https://testnet.bscscan.com'
}

export const BSC_NODE_URL = {
    MAINNET: [
        "https://bsc-dataseed1.ninicoin.io/",
        "https://bsc-dataseed.binance.org/",
        "https://bsc-dataseed1.defibit.io/",
    ],
    TESTNET: ['https://data-seed-prebsc-1-s2.binance.org:8545/']
}

export const STAKING_CONTRACT_ADDRESS = {
    MAINNET: '0x85B3eEE16E4867b178607Ac458E5319C6FB2dba6',
    TESTNET: '0xe0b0C16038845BEd3fCf70304D3e167Df81ce225'
}
export const BSC_CSWAP_ADDRESS = {
    MAINNET: '0x5A726a26eDB0Df8Fd55f03cc30aF8A7cEa81e78D',
    TESTNET: '0xe0d24e7695fd9dcc57a097388811fbaeece68ce7'
}

// export const chainId 